<template>
    <dx-popup
        :drag-enabled="false"
        height="180"
        width="450"
        :hide-on-outside-click="false"
        :show-close-button="false"
        :show-title="true"
        :visible="true"
        title="Идет сохранение"
    >
        <ProgressBar
            mode="indeterminate"
            class="progress"
            style="height: 10px; z-index: 1502; width: 100%; background-color: #f2f2f2; margin-top: 25px"
        />
    </dx-popup>
</template>
<script>
export default {
    name: 'save-userdata-popup',
};
</script>
<script setup>
import { DxPopup } from 'devextreme-vue';
import ProgressBar from 'primevue/progressbar';
</script>
<style scoped>
:deep(.p-progressbar-value::before) {
    background-color: #286eb6 !important;
}

:deep(.p-progressbar-value::after) {
    background-color: #286eb6 !important;
}
</style>
